import classNames from "classnames"
import React from "react"

import Section from "../../elements/V2/Section"
import LayoutItem from "../Layouts/LayoutItem"

import TextButton from "@components/elements/V2/Buttons/TextButton"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import {
  getAccentColor,
  getBackgroundColorClass,
  getGradientFromColorClass,
  getGradientToColorClass,
} from "@utils/V2/color"

type Props = {
  title: string
  description: string
  backgroundColor?: Color
  bannerBackgroundColor: Color
  bannerSecondaryBackgroundColor?: Color
  CTATitle: string
  CTAText: string
  CTALink: string | YocoCom.YocoLink
  CTAColor: Color
  mobileGridOrder?: number
}

const RightCTABanner = ({
  title,
  description,
  backgroundColor,
  bannerBackgroundColor,
  bannerSecondaryBackgroundColor,
  CTATitle,
  CTAText,
  CTALink,
  CTAColor,
  mobileGridOrder,
  ...props
}: Props) => {
  const leftTextColor = getAccentColor(bannerBackgroundColor)
  const rightTextColor = getAccentColor(
    bannerSecondaryBackgroundColor ?? bannerBackgroundColor
  )

  return (
    <LayoutItem
      as={Section}
      className={classNames(
        "py-3xl",
        backgroundColor && getBackgroundColorClass(backgroundColor)
      )}
      mobileGridOrder={mobileGridOrder}
      {...props}
    >
      <div
        className={classNames(
          bannerSecondaryBackgroundColor
            ? [
                "bg-gradient-to-b sm:bg-gradient-to-r",
                getGradientFromColorClass(bannerBackgroundColor),
                "from-0% to-60%",
                getGradientToColorClass(bannerSecondaryBackgroundColor),
              ]
            : getBackgroundColorClass(bannerBackgroundColor),
          "rounded-lg flex flex-col justify-between gap-24 overflow-hidden p-32 sm:flex-row sm:items-center md:p-60"
        )}
      >
        <div>
          <Typography
            element="h2"
            size="lead-sm-dual"
            font="grotesk"
            weight="medium"
            color={leftTextColor}
            text={title}
          />
          <Typography
            size="body-lg"
            font="grotesk"
            weight="book"
            color={leftTextColor}
            text={description}
            className="mt-10"
          />
        </div>

        <div className="flex w-full flex-col items-start gap-16 sm:w-auto">
          <Typography
            element="h3"
            size="lead-lg"
            font="grotesk"
            weight="medium"
            color={rightTextColor}
            text={CTATitle}
          />
          <TextButton
            style="icon"
            text={CTAText}
            linkUrl={CTALink}
            icon={<ArrowIcon />}
            color={CTAColor}
          />
        </div>
      </div>
    </LayoutItem>
  )
}

export default RightCTABanner
